import React from 'react'

const TraceabilityOperatorMenu: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4949_40979)"
      fillOpacity="0.1"
    />
    <path
      d="M23.5933 21.1562C23.392 20.0631 22.8455 19.1715 22.0113 18.4236C20.9758 17.5032 19.7102 16.9566 18.3871 16.5539C18.0707 16.4389 17.8118 16.4677 17.5817 16.7265C17.5242 16.8128 17.4091 16.8416 17.3516 16.9279C16.8914 17.273 16.4599 17.6182 15.9997 17.9921C15.9422 17.9346 15.8847 17.9058 15.8559 17.8771C15.3094 17.4456 14.7629 17.0142 14.2164 16.5827C14.1301 16.5252 13.9862 16.4677 13.9 16.4964C12.6056 16.8416 11.3687 17.3593 10.3045 18.1935C9.32651 18.9413 8.66494 19.8618 8.40607 21.0699C8.29102 21.6739 8.43483 22.0478 8.95258 22.3642C9.24022 22.5368 9.52786 22.7094 9.84426 22.8532C11.3112 23.5435 12.8645 23.8312 14.4752 23.9462C16.2298 24.0613 17.9844 24.0038 19.7102 23.6586C20.9183 23.3997 22.0689 23.0258 23.1044 22.3355C23.5646 22.0478 23.7084 21.6739 23.5933 21.1562ZM16.5175 21.9328C16.2873 22.4218 16.3161 22.3355 15.9997 22.8245C15.7984 22.508 15.6258 22.1916 15.4244 21.904C15.1656 21.5301 15.1368 21.2137 15.2518 20.811C15.5107 19.9193 15.7408 18.9989 15.9709 18.0784C15.9997 18.0784 15.9997 18.0784 16.0285 18.0784C16.1435 18.5099 16.2586 18.9126 16.3736 19.344C16.5462 19.9768 16.575 20.0631 16.7476 20.6959C16.9489 21.3575 16.6613 21.6739 16.5175 21.9328ZM20.2855 20.8685H18.7898C18.6747 20.8685 18.5597 20.7535 18.5597 20.6384C18.5597 20.5233 18.6747 20.4083 18.7898 20.4083H20.2855C20.4006 20.4083 20.5156 20.5233 20.5156 20.6384C20.5156 20.7535 20.4293 20.8685 20.2855 20.8685Z"
      fill="#052351"
    />
    <path
      d="M16.0284 16.0361C14.5902 15.9786 13.4972 15.3458 12.7781 14.1377C11.8001 12.5557 12.059 10.4272 13.3821 9.10404C14.8779 7.60832 17.2365 7.63709 18.7034 9.16157C20.7169 11.2613 19.9403 14.828 17.2365 15.806C17.0639 15.8635 16.8913 15.9211 16.69 15.9498C16.4599 16.0073 16.2298 16.0073 16.0284 16.0361Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4949_40979"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default TraceabilityOperatorMenu
